import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";

import {  getToken} from "../context/auth/Token";

declare global {
  interface Window {
    REACT_APP_GRAPHQL_ENDPOINT: string;
  }
}

const httpLink = createHttpLink({
  uri: window.REACT_APP_GRAPHQL_ENDPOINT,
  headers: {
    authorization: `Bearer ${getToken().token}`,
  },
});

const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
});

export default client;
